<template>
  <div class="subscribe-box">
    <div class="head">
      关于订阅
      <span class="mask"></span>
    </div>
    <p class="title">
      <span class="point"></span>
      <span>每早您可及时收到当日宣讲时间表</span>
    </p>
    <div class="checked-box">
      <span class="checked-title">订阅推送</span>
      <van-switch
        size="18px"
        v-model="checked"
        :loading="loading"
        active-color="#34AE7F"
        inactive-color="#dcdee0"
        @change="changeCheck(checked)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "SubscribeBox",
  data() {
    return {
      checked: false,
      loading: false,
      deleteObj: {},
      params: {
        Address: "",
        Areaid: "",
        Cityid: "",
        Fkuserid: 0,
        From: "",
        Id: 0,
        Name: "",
        Openid: "",
        Phone: "",
        Provinceid: "",
        School: "",
        Schoolid: 0,
        Type: 1,
      },
    };
  },
  mounted() {
    this.getSubscribe(1);
  },

  methods: {
    getSubscribe(type) {
      let that = this;
      return new Promise((resolve, reject) => {
        this.axios.get("/api/user/subscribe/get").then(function (res) {
          console.log("res", res,type);
          if (res.data.code == 0) {
            if (type == 1) {
              if (res.data.data.Id == 0) {
                that.checked = false;
              } else {
                that.checked = true;
              }
            }
            that.deleteObj = res.data.data;
            resolve(res.data.data);
          } else {
            reject(res.data.msg);
          }
        });
      });
    },
    changeCheck(value) {
      console.log(value);
      this.loading = true;
      if (value) {
        this.resetParams();
        this.add();
      } else {
        this.delete();
      }
    },
    resetParams() {
      console.log(1231111, this.$store.state.userInfo);
      let userInfo = this.$store.state.userInfo;
      if (userInfo.Ext && userInfo.Ext.Fkuserid) {
        this.params.Address = userInfo.Ext.Address;
        this.params.Areaid = userInfo.Ext.Areaid;
        this.params.Cityid = userInfo.Ext.Cityid;
        this.params.Fkuserid = userInfo.Ext.Fkuserid;
        this.params.From = userInfo.Ext.From;
        this.params.Name = userInfo.Ext.Name;
        this.params.Phone = userInfo.Ext.Phone;
        this.params.Provinceid = userInfo.Ext.Provinceid;
        this.params.School = userInfo.Ext.School;
        this.params.Schoolid = userInfo.Ext.Schoolid;
      }
    },
    resetDeleteObj() {
      this.deleteObj = {
        Address: "",
        Areaid: "",
        Cityid: "",
        Fkuserid: 0,
        From: "",
        Id: 0,
        Name: "",
        Openid: "",
        Phone: "",
        Provinceid: "",
        School: "",
        Schoolid: 0,
        Type: 1,
      };
    },
    add() {
      console.log(
        this.params,
        this.deleteObj,
        this.deleteObj.Id == 0,
        this.params.Schoolid != 0
      );
      if (this.deleteObj.Id == 0 && this.params.Schoolid != 0) {
        this.axios.post("/api/user/subscribe/add", this.params).then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.$toast("订阅成功");
          } else {
            this.$toast("订阅失败");
            this.checked = false;
          }
        });
      } else {
        // this.$toast("订阅失败");
        this.$toast("请先注册");
        this.loading = false;
        this.checked = false;
      }
    },
    delete() {
      console.log(this.deleteObj);
      if (this.deleteObj.Id == 0) {
          let that=this
        this.getSubscribe(2).then(() => {
          that.handleDelete();
        }).then(err=>{
            console.log(err);
        });
      } else {
        this.handleDelete();
      }
    },
    handleDelete() {
      console.log(this.deleteObj);
      if (this.deleteObj.Id != 0) {
        this.axios
          .post("/api/user/subscribe/delete", this.deleteObj)
          .then((res) => {
            this.loading = false;
            if (res.data.code == 0) {
              this.$toast("取消订阅成功");
              this.resetDeleteObj();
            } else {
              this.$toast("取消订阅失败");
              that.checked = true;
            }
          });
      } else {
        this.$toast("取消订阅失败");
        this.loading = false;
        this.checked = true;
      }
    },
  },
};
</script>

<style scoped>
.subscribe-box {
  width: 250px;
  height: 190px;
  line-height: 20px;
  border-radius: 12px;

  background-color: rgba(255, 255, 255, 100);
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  text-align: center;
  box-shadow: 10px 4px 40px -20px rgba(86, 97, 215, 1);
  font-family: Arial;
  border: 2px solid rgba(86, 97, 215, 100);
}
.head {
  height: 40px;
  margin: 28px 25px 20px 25px;
  text-align: center;
  border: 2px solid rgba(86, 97, 215, 100);
  line-height: 40px;
  border-radius: 8px;
  font-size: 18px;
  position: relative;
}
.mask {
  position: absolute;
  display: inline-block;
  height: 20px;
  width: 10px;
  top: 6px;
  right: -5px;
  background: #fff;
}
.title {
  color: #5661d7;
  font-size: 12px;
}
.point {
  background-color: rgba(86, 97, 215, 100);
  width: 8px;
  height: 8px;
  border-radius: 4px;
  display: inline-block;
}
.checked-box {
  padding-top: 20px;
  font-size: 18px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  justify-content: center;
  align-items: center;
  width: 150px;
  margin: auto;
  justify-items: right;
}
</style>



// WEBPACK FOOTER //
// src/components/subscribe-box.vue